import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TParty {
  id: string;
  firstName?: string;
  lastName?: string;
  sex?: string;
  name?: string;
  fatherName?: string;
  motherSurname?: string;
}

export interface IParty extends TParty {}

const Party = Model((model: TParty): IParty => {
  const _party: TParty = Object.assign({}, model);

  let create = ValidatableObject;

  let party = {
    get id() {
      return _party.id;
    },
    set id(value) {
      _party.id = value;
    },
    get firstName() {
      return _party.firstName;
    },
    set firstName(value) {
      _party.firstName = value;
    },
    get lastName() {
      return _party.lastName;
    },
    set lastName(value) {
      _party.lastName = value;
    },
    get sex() {
      return _party.sex;
    },
    set sex(value) {
      _party.sex = value;
    },
    get name() {
      return _party.name;
    },
    set name(value) {
      _party.name = value;
    },
    get fatherName() {
      return _party.fatherName;
    },
    set fatherName(value) {
      _party.fatherName = value;
    },
    get motherSurname() {
      return _party.motherSurname;
    },
    set motherSurname(value) {
      _party.motherSurname = value;
    }
  };
  return create(party);
});

export default Party;
